$(document).ready(function(){
	var pj = GetURLParameter('pj');
    var qty = GetURLParameter('qnt');
    if(typeof qty == 'undefined'){
        qty='';
      }else{
        $('#Quantity').val(qty);
      }
    if(typeof pj == 'undefined'){
      pj='';
    }else{
      pj='&pj='+pj;
      setTimeout( function() {$('#personalize').trigger('click'); },1000);
    }
   
    
    /** remove comment if want to split description
    if  ($('#SingleOptionSelector-1').is(":visible")) {
      var test = $('#SingleOptionSelector-1 option:selected').attr("op-select");
    }else{
    	var test = $('.single-option-selector option:selected').attr("op-select");
    }
    
    if(typeof test == 'undefined'){
   	 $('.product-single__description').show();
    }else{
      $('.product-single__description').hide();
      	$('.'+test+'').show();
    }
    $('.single-option-selector').change(function(){
    	if  ($('#SingleOptionSelector-1').is(":visible")) {
          var test = $('#SingleOptionSelector-1 option:selected').attr("op-select");
        }else{
            var test = $('.single-option-selector option:selected').attr("op-select");
        }
      
      	$('.product-single__description').hide();
      	$('.'+test+'').show();
    });
    **/
    $('.single-option-selector').change(function(){
      setTimeout( function() {
    	var pid = $('select[name="id"] option:selected').attr('value');
        var barcode = $('.barcode_holder div.'+pid).text();
        if(typeof pid == 'undefined' || barcode == ''){
          pid = $('input[name="id"]').val();
          barcode = $('.barcode_holder div.'+pid).text();
        }
      
        if(barcode.indexOf('POD') == 0){
          $('#ip-label').text('Add To Cart');
        }else{
          $('#ip-label').text('Personalize');
        }
      },200);
    });
  
  setTimeout( function() {
  	//$('.shopify-payment-button').hide();
  },200);
  
});
//CUSTOMIZE BUTTON
$('#personalize').click(function(e){
    e.preventDefault();
    personalize();
});

function personalize(){
  localStorage['msrp']='';
  var server = window.location.hostname;
  var pid = $('select[name="id"] option:selected').attr('value');
  var barcode = $('.barcode_holder div.'+pid).text();
  if(typeof pid == 'undefined' || barcode == ''){
    pid = $('input[name="id"]').val();
    barcode = $('.barcode_holder div.'+pid).text();
  }

  var vendor = $('.barcode_holder div.vendor_'+pid).text();
  var option1 = $('.barcode_holder div.option1_'+pid).text();
  var option2 = $('.barcode_holder div.option2_'+pid).text();
  var option3 = $('.barcode_holder div.option3_'+pid).text();
  var config = $('.barcode_holder div.config_'+pid).text();
  var mconfig = $('.barcode_holder div.mconfig_'+pid).text();
  var layout = $('.barcode_holder div.layout_'+pid).text();
  var mlayout = $('.barcode_holder div.mlayout_'+pid).text();
  var locale = $('.barcode_holder div.locale_'+pid).text();
  var mlocale = $('.barcode_holder div.mlocale_'+pid).text();
  var gallery = $('.barcode_holder div.gallery_'+pid).text();
  var css = $('.barcode_holder div.css_'+pid).text();
  var renderer = $('.barcode_holder div.renderer_'+pid).text();
  var etc = $('.barcode_holder div.etc_'+pid).text();
  var metc = $('.barcode_holder div.metc_'+pid).text();
  var msrp = $('.barcode_holder div.msrp_'+pid).text();
  var sample = $('.barcode_holder div.sample_'+pid).text();
  var quantity = $('#Quantity').val();
  var redirect = $('.barcode_holder div.redirect_'+pid).text();
  redirect = "&redirect="+redirect;
  if(typeof quantity == 'undefined'){
    quantity = 1;
  }
  var SpecialInstruction = $('#note').val();
  localStorage['specialInstruction']=SpecialInstruction;
  var color = "nocolor";
  var size = "nosize";
  var hex='';
  if(option1.length != 0){
    var attr = option1.split("_");
    if (attr[1].toUpperCase() === "SIZE") {
      size = attr[0];
    }
    var attr = option1.split("_");
    if (attr[1].toUpperCase() === "COLOR" || attr[1].toUpperCase() === "COLOUR") {
      color = attr[0];
    }
  }
  if(option2.length != 0){
    var attr = option2.split("_");
    if (attr[1].toUpperCase() === "COLOR" || attr[1].toUpperCase() === "COLOUR") { 
      color = attr[0];
    }
    var attr = option2.split("_");
    if (attr[1].toUpperCase() === "SIZE") {
      size = attr[0];
    }
  }
  if(option3.length != 0){
    var attr = option3.split("_");
    if (attr[1].toUpperCase() === "COLOR" || attr[1].toUpperCase() === "COLOUR") {
      color = attr[0];
    }
    var attr = option3.split("_");
    if (attr[1].toUpperCase() === "SIZE") {
      size = attr[0];
    }
  }

  if(color !='nocolor'){
    hex = color.split('|');
    color = hex[0].replace(/\s/g, '');
    if(hex.length >1){
      	var str = hex[1].replace(/\s/g, '');
  		hex = '&hex=' + str;
    }else{
    	hex='';
    }
  }
  if(sample !=""){ sample = "&sample=1";}

  etc = etc.replace(/&/gi,'|');
  etc = etc.replace('|','&');
  metc = metc.replace(/&/gi,'|');
  metc = metc.replace('|','&');
  if(barcode.indexOf('POD') == 0){
    
    var myform = $('#personalize').closest('form');
    barcode = barcode.replace('POD','');
    myform.append('<input type="hidden" name="properties[_barcode]" value="'+barcode+'" /><input type="hidden" name="properties[_server]" value="'+server+'" /><input type="hidden" name="properties[_vendor]" value="'+vendor+'" />');
    setTimeout(function() {
      myform.submit();
    }, 1); 
    
  }else{
 	var sid = 'sid=' + pid;
    var server = window.location.hostname;
    var pj = GetURLParameter('pj');
    var qnt = GetURLParameter('qnt');
    
    if(typeof qnt != 'undefined'){
     quantity=qnt;
    }
    
    if(typeof pj == 'undefined'){
      pj='';
    }else{
      pj='&pj='+pj;
    }
    if(msrp!=''){msrp='&'+msrp;}
    var linkurl =  sid +'&vendor='+ vendor +'&gid='+ barcode +'&qnt=' + quantity + "&color=" +color + "&size=" + size + hex + config + mconfig + layout + mlayout + locale + mlocale + gallery + renderer + metc + msrp + sample + etc + redirect + css + pj +'&virtual=no';
    var domainurl = 'https://prod2.ipersonalyzenetwork.com/integration/dftba/api?action=design&domain='+ server;
  	var iframeurl = domainurl + '&' + linkurl;
    
    if($(window).width() > 850){
      var width = $(window).width()*0.9;
      if(width>830)width=800;
      var height = $(window).height()*0.9;
      if(height>560)height=560;

      $.fancybox1.open({
      src  : iframeurl,
      type : 'iframe',
      opts : {
          beforeShow: function(){
              $("#wrapthewrap").css({'overflow':'hidden'});
          },
          afterClose: function(){
              $("#wrapthewrap").css({'overflow':'visible'});
          },
          touch: {
            vertical: false, // Allow to drag content vertically
            momentum: false // Continue movement after releasing mouse/touch when panning
          },
        clickSlide : false
      }
      });
    }else{
      var width = window.innerWidth ? window.innerWidth : $(window).width();
      var height = window.innerHeight ? window.innerHeight -30 : $(window).height()-30;
      window.scrollTo(1,0);
      $('html').addClass('customiser-on');
      $('#customiser-helper .inner').html('<iframe style="width:'+width+'px; height:'+height+'px" src="'+iframeurl+'"></iframe>');
      $('#customiser-helper').fadeIn();
	  $('.site-header').hide();
      $('#customiser-helper #customiser-back').click(function(e){
        e.preventDefault();
        $('.site-header').show();
        $('#customiser-helper').fadeOut();
        $('html').removeClass('customiser-on');
      });

      $(window).resize(function(){
        var width = window.innerWidth ? window.innerWidth : $(window).width();
        var height = window.innerHeight ? window.innerHeight -30 : $(window).height()-30;
        $('#customiser-helper iframe').css({'width':width,'height':height});
      });
    }
  }
}
function GetURLParameter(sParam){

    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');

    for (var i = 0; i < sURLVariables.length; i++)
    {

        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam)
        {

            return sParameterName[1];

        }
    }
}
